module.exports = __webpack_public_path__ + "static/media/group-179854.06bc65eb.svg";